module.exports = __webpack_public_path__ + "static/media/environment.74abcfe5.svg";